/* EOS sticky add-to-cart (PDP rebuild, v3 2026-08-21 late).
   Oscillation-proof by construction:
   - Visibility toggled ONLY via transform+opacity classes (fixed element,
     zero layout impact ever — showing/hiding cannot move the page or the
     thresholds).
   - All thresholds live in DOCUMENT coordinates and are computed only on
     init / debounced resize / variant re-render / doc-height drift — never
     per scroll event.
   - The viewport-height reference (vhRef) is the LARGEST innerHeight seen
     and never shrinks, so mobile URL-bar collapse/expand (which fires
     resize during scroll and shifts innerHeight by ~60-114px) cannot move
     the footer threshold at all. (This was the v2 flicker: the footer band
     was 88px, narrower than the URL-bar delta, and was re-read from
     innerHeight on every scroll event.)
   - Dead zones (tuned 21-08 after Safak's timing feedback): asymmetric
     144px button band — show the moment the ATC button leaves the viewport
     top (+24px), hide only when it is 120px back inside; 200px footer band
     — bar persists until the (green scheme-3) footer genuinely enters the
     viewport (+40px), releases 160px before it.
   - MIN_TRAVEL guard: after any state change, the next change needs 48px
     of real scroll travel — rapid alternation is impossible.
   - In-bar pack selector for multi-variant products: two-way sync with
     Dawn's variant picker (radio dispatch drives Dawn's own pipeline for
     price, unit price, gallery image and availability). */
(function () {
  function init() {
    var bar = document.querySelector('[data-eos-sticky-atc]');
    if (!bar || bar.getAttribute('data-eos-init') === '1') return;
    bar.setAttribute('data-eos-init', '1');
    var sid = bar.getAttribute('data-main-section') || 'main';
    var formId = bar.getAttribute('data-main-form') || ('product-form-' + sid);
    var form = document.getElementById(formId);
    if (!form) return;
    var info = document.getElementById('ProductInfo-' + sid) || document.querySelector('product-info') || document;
    var btn = bar.querySelector('[data-eos-sticky-submit]');
    var priceEl = bar.querySelector('[data-eos-sticky-price]');
    var select = bar.querySelector('[data-eos-sticky-select]');
    var footer = document.querySelector('.footer') || document.querySelector('footer');
    var variantMap = null;
    var mapEl = document.querySelector('[data-eos-variant-map]');
    if (mapEl) { try { variantMap = JSON.parse(mapEl.textContent); } catch (e) { variantMap = null; } }

    // --- constants (px, document coordinates) ---
    // Asymmetric band around the ATC button (tuned 21-08 after Safak's test:
    // the bar must appear essentially the moment the button leaves the top
    // of the viewport, and hide only when it is comfortably back in view):
    var SHOW_AT = 24;    // show once the button bottom is 24px above the viewport top
    var HIDE_IN = 120;   // hide once the button bottom is 120px back INSIDE the viewport
    // Footer (the green scheme-3 footer): keep the bar until the footer
    // genuinely enters the viewport:
    var FOOT_IN = 40;    // suppress once the footer top is ~40px inside the viewport
    var FOOT_OUT = 160;  // release once it is 160px below again (band: 200px,
                         // still wider than the ~114px mobile URL-bar delta)
    var MIN_TRAVEL = 48; // minimum scroll travel between two state changes

    // --- anchors (recomputed only on real layout events, never per scroll) ---
    var btnBottomDoc = Infinity, footerTopDoc = Infinity, docH = 0, vhRef = 0;
    var pastBtn = false, atFooter = false, shown = false, lastChangeY = -1e9;
    var ticking = false;

    function mainBtn() {
      var f = document.getElementById(formId);
      return (f && f.querySelector('.product-form__submit')) || null;
    }

    function soldOut() {
      var b = mainBtn();
      return !b || b.hasAttribute('disabled') || b.getAttribute('aria-disabled') === 'true';
    }

    function scrollYNow() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function computeAnchors() {
      var y = scrollYNow();
      var b = mainBtn();
      if (b) {
        var r = b.getBoundingClientRect();
        if (r.width || r.height) btnBottomDoc = r.bottom + y; // ignore detached/zero rects
      }
      if (footer) {
        var fr = footer.getBoundingClientRect();
        if (fr.width || fr.height) footerTopDoc = fr.top + y;
      }
      docH = document.documentElement.scrollHeight;
      vhRef = Math.max(vhRef, window.innerHeight || 0); // never shrinks mid-scroll
    }

    function setShown(next, y) {
      if (next === shown) return;
      if (Math.abs(y - lastChangeY) < MIN_TRAVEL) return; // dead zone between changes
      shown = next;
      lastChangeY = y;
      bar.classList.toggle('eos-sticky-atc--show', shown);
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
    }

    function syncPrice() {
      if (!priceEl) return;
      var pc = document.querySelector('#price-' + sid + ' .price');
      if (!pc) return;
      var src = pc.classList.contains('price--on-sale')
        ? pc.querySelector('.price__sale .price-item--sale')
        : pc.querySelector('.price__regular .price-item--regular');
      if (src && src.textContent.trim() && priceEl.textContent !== src.textContent.trim()) {
        priceEl.textContent = src.textContent.trim();
      }
    }

    function currentVariantId() {
      var input = form.querySelector('input[name="id"], select[name="id"]');
      return input ? String(input.value) : null;
    }

    function syncSelect() {
      if (!select) return;
      var id = currentVariantId();
      if (id && select.value !== id) select.value = id; // assignment fires no change event: no loop
    }

    function evaluate() {
      var y = scrollYNow();
      // lazy images/recommendations can move anchors: recompute on drift
      if (Math.abs(document.documentElement.scrollHeight - docH) > 50) computeAnchors();
      var out = soldOut();
      if (btn) btn.disabled = out;
      // button latch (document coords, asymmetric band: show right as the
      // button exits the top, hide only when it is well back in view)
      if (y > btnBottomDoc + SHOW_AT) pastBtn = true;
      else if (y < btnBottomDoc - HIDE_IN) pastBtn = false;
      // footer latch (vhRef is constant during scroll: URL-bar resize cannot flip it)
      var vb = y + vhRef;
      if (vb > footerTopDoc + FOOT_IN) atFooter = true;
      else if (vb < footerTopDoc - FOOT_OUT) atFooter = false;
      setShown(pastBtn && !atFooter && !out, y);
      syncPrice();
      syncSelect();
    }

    function requestEvaluate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; evaluate(); });
    }

    var resizeTimer = null;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { computeAnchors(); evaluate(); }, 150);
    }

    // --- in-bar pack selector -> Dawn's variant picker ---
    if (select) {
      select.addEventListener('change', function () {
        var id = select.value;
        var entry = variantMap && variantMap[id];
        var title = entry && entry.t;
        if (!title) { syncSelect(); return; }
        var picker = document.querySelector('variant-selects, variant-radios');
        var applied = false;
        if (picker) {
          var radios = picker.querySelectorAll('input[type="radio"]');
          for (var i = 0; i < radios.length; i++) {
            if (radios[i].value === title) {
              if (!radios[i].checked) {
                radios[i].checked = true;
                radios[i].dispatchEvent(new Event('change', { bubbles: true }));
              }
              applied = true;
              break;
            }
          }
          if (!applied) {
            var sels = picker.querySelectorAll('select');
            for (var j = 0; j < sels.length; j++) {
              var s = sels[j], has = false;
              for (var k = 0; k < s.options.length; k++) if (s.options[k].value === title) { has = true; break; }
              if (has) {
                if (s.value !== title) { s.value = title; s.dispatchEvent(new Event('change', { bubbles: true })); }
                applied = true;
                break;
              }
            }
          }
        }
        if (!applied) syncSelect(); // could not drive the main picker: revert the bar UI
      });
    }

    window.addEventListener('scroll', requestEvaluate, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', function () { vhRef = 0; onResize(); }, { passive: true });
    window.addEventListener('load', function () { computeAnchors(); evaluate(); });

    // Dawn swaps buy-button/price nodes on variant change: re-anchor + re-sync.
    var mo = new MutationObserver(function () { computeAnchors(); requestEvaluate(); });
    mo.observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    form.addEventListener('change', function () { setTimeout(function () { computeAnchors(); evaluate(); }, 80); });

    // late layout settles (fonts, images, recommendations fetch)
    setTimeout(function () { computeAnchors(); evaluate(); }, 1200);
    setTimeout(function () { computeAnchors(); evaluate(); }, 3500);

    bar.removeAttribute('hidden'); // CSS keeps it off-screen until --show
    computeAnchors();
    evaluate();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
